module.exports = __webpack_public_path__ + "static/media/call.978dff77.svg";